import Box from '@mui/material/Box';

import ExploreSection from './ExploreSection';
import RecentlyVisitedSection from './RecentlyVisitedSection';
import SubApps from './SubApps';

const HomeFooter = (): React.JSX.Element => {
	return (
		<>
			<Box
				sx={{
					width: '100%',
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					flexWrap: 'wrap',
				}}>
				<Box
					sx={{
						width: { xs: '100%', sm: 'auto' },
						flexGrow: 3,
						mb: 4,
					}}>
					<RecentlyVisitedSection />
				</Box>
				<Box
					sx={{
						width: { xs: '100%', md: 'auto' },
						flexGrow: 1,
						mb: 4,
					}}>
					<SubApps />
				</Box>
				<Box
					sx={{
						width: { xs: '100%', md: 'auto' },
						flexGrow: 1,
					}}>
					<ExploreSection />
				</Box>
			</Box>
		</>
	);
};

export default HomeFooter;
